import React from 'react';
import parse from 'html-react-parser';
import { BodyTitle } from './bseStyle';
import IconStar2 from '../../../../../../../../assets/icons/IconStar2.svg';

interface BSEPinOneProp {
  PropPinOne: any;
  paddingTopBoddyTitle: any;
  marginBodyTitle: any;
}

const BSEPinone = (props: BSEPinOneProp) => {
  const { PropPinOne, paddingTopBoddyTitle, marginBodyTitle } = props;

  return (
    <BodyTitle paddingTop={paddingTopBoddyTitle} margin={marginBodyTitle}>
      <img className="MR" src={IconStar2} alt="IconStar2" />
      <p>{parse(PropPinOne)}</p>
    </BodyTitle>
  );
};
export default BSEPinone;
